import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=bfe04c7e&"
import script from "./productCategory.vue?vue&type=script&lang=js&"
export * from "./productCategory.vue?vue&type=script&lang=js&"
import style0 from "./productCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports